import { useState } from 'react';
import { Send } from 'lucide-react';

interface CommentEditorProps {
  onSubmit: (body: string) => void;
  submitting?: boolean;
}

export function CommentEditor({ onSubmit, submitting }: CommentEditorProps) {
  const [body, setBody] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!body.trim() || submitting) return;
    onSubmit(body.trim());
    setBody('');
  };

  return (
    <form onSubmit={handleSubmit} className="border border-ems-border rounded-lg bg-ems-bg-card-hover">
      <textarea
        value={body}
        onChange={e => setBody(e.target.value)}
        placeholder="Add a reply..."
        rows={3}
        className="w-full px-4 py-3 text-sm text-ems-text-primary placeholder:text-ems-text-muted bg-transparent resize-none focus:outline-none"
      />
      <div className="flex items-center justify-end px-4 py-2 border-t border-ems-border">
        <button
          type="submit"
          disabled={!body.trim() || submitting}
          className="flex items-center gap-2 px-4 py-1.5 bg-ems-green text-ems-bg rounded-lg text-sm font-medium hover:bg-ems-green-bright disabled:opacity-40 disabled:cursor-not-allowed transition-colors"
        >
          <Send className="w-3.5 h-3.5" />
          {submitting ? 'Sending...' : 'Send'}
        </button>
      </div>
    </form>
  );
}
